import { type CSSProperties } from 'react';
import { LoaderSymbol } from './LoaderSymbol';

interface Props {
  /** While true, render the client's configured loading SYMBOL instead of `icon`. */
  busy: boolean;
  /** The Tabler icon class shown when not busy (e.g. "ti-device-floppy"). */
  icon: string;
  /** Symbol/icon pixel size (default 14 — sized for an in-button icon). */
  size?: number;
  /** Optional style forwarded to the idle `<i>` (colour, font-size, etc.). */
  style?: CSSProperties;
}

/**
 * In-button loading icon (§18.6).  Replaces the old per-button pattern
 * `<i className={`ti ${icon}${busy ? ' sr-spin' : ''}`} />` so that even the
 * tiny spinner inside a Save / Refresh / Generate button becomes the client's
 * configured loading symbol (ring / dots / bars / …) in the configured colour —
 * one shared affordance, no bespoke per-form spinner.
 */
export function BusyIcon({ busy, icon, size = 14, style }: Props) {
  return busy ? <LoaderSymbol size={size} /> : <i className={`ti ${icon}`} style={style} />;
}
